import type { Step } from '@/components/wizard/Step';

import type { AzureOwnCloudState } from './azureOwnCloudState';
import { ConnectAzureOwnAppRegistrations } from './connectAzureOwnAppRegistrations';
import { ConnectAzureOwnScanningAccount } from './connectAzureOwnScanningAccount';
import { ConnectAzureOwnVaultAccount } from './connectAzureOwnVaultAccount';

import { ConnectAzureSourceAccount } from '../connectAzureSourceAccount';

export const azureOwnCloudFlow: Step<AzureOwnCloudState> = {
  id: 'management_access',
  Component: ConnectAzureOwnAppRegistrations,
  nonReturnable: false,
  next: [
    {
      id: 'scanning_account_setup',
      Component: ConnectAzureOwnScanningAccount,
      next: [
        {
          id: 'vault_account_setup',
          Component: ConnectAzureOwnVaultAccount,
          next: [
            {
              id: 'source_connection',
              Component: ConnectAzureSourceAccount,
            },
          ],
        },
      ],
    },
  ],
};
